// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__1MoHU","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__3lTao"};